import { render, staticRenderFns } from "./mypage-aside.vue?vue&type=template&id=0b164afa&"
import script from "./mypage-aside.vue?vue&type=script&lang=js&"
export * from "./mypage-aside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports